module.exports = __webpack_public_path__ + "static/innovative-c5d45bceaa6651fd914df15413703fc0.svg";